import type { AppRouteRecordRaw } from "#src/router/types";

import { IconReader } from "#src/components/iconReader/IconReader";
import ContainerLayout from "#src/layout/container-layout";
import { createElement, lazy } from "react";

const IndentPage = lazy(() => import("#src/features/Indents"));
const BudgetAllocatePage = lazy(() => import("#src/features/BudgetAllocations"));
const ApprovalMatricesPage = lazy(() => import("#src/features/ApprovalMatrices"));
const RfqsPage = lazy(() => import("#src/features/Rfqs"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/indent",
		Component: ContainerLayout,
		handle: {
			title: "Indent",
			icon: createElement(IconReader, { name: "filesearch" }) as any,
			order: 5,
			keepAlive: true,
		},
		children: [
			{
				path: "/indent/indents",
				Component: IndentPage,
				handle: { title: "Indents" },
			},
			{
				path: "/indent/budget-allocations",
				Component: BudgetAllocatePage,
				handle: { title: "Budget Allocate" },
			},
			{
				path: "/indent/approval-matrices",
				Component: ApprovalMatricesPage,
				handle: { title: "Approval Matrices" },
			},
			{
				path: "/indent/rfqs",
				Component: RfqsPage,
				handle: { title: "RFQs" },
			},
		],
	},
];

export default routes;
